import dayjs from 'dayjs';
import { genarateRandomString } from '@/utils';
var location = window.location;
var hostname = location.hostname;
export var debug = hostname === 'localhost' || hostname.indexOf('local.') !== -1 || hostname.indexOf('10.') !== -1;
export var useTestApi = hostname.indexOf('test') !== -1;
export var routes = {
    index: '/',
    login: '/login',
    miniLogin: '/miniLogin',
    register: '/register',
    /** 填写资质页面 */
    certification: '/certification/update',
    viewCertification: '/certification/view',
    createCertification: '/certification/create',
    certificationRedirect: '/certification',
    /** 补充资质跳转页面 */
    certificationSupplement: '/certification-supplement',
    certificationExtend: '/certification/extend',
    // 个人账户
    editPersonalCertification: '/certification/personal/edit',
    viewPersonalCertification: '/certification/personal/view',
    /** 选择身份 */
    chooseService: '/chooseService',
    choosePersonal: {
        path: 'personal',
        name: 'choose-personal',
    },
    chooseCompany: {
        path: 'company',
        name: 'choose-company'
    },
    /** 提交完成页面，显示待审核状态 */
    platformIndex: '/platformIndex',
    resetPassword: '/resetPassword'
};
export var platformCode = {
    fin: 'fin',
    trade: 'trade',
    cenpur: 'cenpur',
    bid: 'bid',
    logistics: 'logistics',
    wms: 'wms',
    oa: 'oa',
    eq: 'equipmententerprise',
};
export var indentityCode = {
    fin: {
        agency: 'fin_agency',
        borrower: 'fin_borrower',
    },
    cenpur: {
        supplier: 'cenpur_supplier',
        purchaser: 'cenpur_purchaser',
    },
    bid: {
        supplier: 'bid_supplier',
        purchaser: 'bid_purchaser',
    },
};
export var certificationStatusCode;
(function (certificationStatusCode) {
    certificationStatusCode["opened"] = "2";
    certificationStatusCode["openning"] = "1";
    certificationStatusCode["reject"] = "3";
})(certificationStatusCode || (certificationStatusCode = {}));
export var patterns = {
    tel: /^1\d{10}$/,
    website: /^((https?:\/\/)?(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/,
    idCard: /(^[1-9]\d{5}(19|20)\d{2}\d{4}\d{3}(\d|[xX])$)|(^[1-9]\d{5}\d{2}\d{4}\d{3}$)/,
};
export var openningAndOpenedStatus = [certificationStatusCode.opened, certificationStatusCode.openning];
/** 招采平台页面url */
export var bidPlatformUrl = 'https://www.zlgx.com'; // FIXME:修改为正式的招采平台页面地址
export var enterpriseCertRules = {
    companyNameZh: '请输入公司名称',
    address: '请输入详细地址',
    registerTime: '请选择公司注册时间',
    contactPerson: '请输入联系人',
    contactPhone: function (value) {
        if (!value) {
            return '请输入联系电话';
        }
        if (!(patterns.tel.test(value))) {
            return '联系电话格式不正确';
        }
        return '';
    },
    // 受邀钢厂
    invitedSteel: function (value) {
        if (value === '###') {
            return '请选择受邀钢厂';
        }
        return '';
    },
    bizLicense: '请上传营业执照',
    accountLicense: function (value, values) {
        if (values.hasCenpur) {
            return value ? '' : '请上传开户许可证';
        }
        return '';
    },
    openBank: function (value, values) {
        if (values.hasCenpur) {
            return value ? '' : '请填写开户行';
        }
        return '';
    },
    accountName: function (value, values) {
        if (values.hasCenpur) {
            return value ? '' : '请填写开户名称';
        }
        return '';
    },
    accountNo: function (value, values) {
        if (values.hasCenpur) {
            return value ? '' : '请填写开户帐号';
        }
        return '';
    },
    authorization: '请上传委托书',
    website: function (value) {
        if (!value) {
            return '';
        }
        return !(patterns.website.test(value)) ? '网址格式不正确' : '';
    },
};
export var bankInfoRules = {
    openBank: '请输入开户行名称',
    accountName: '请输入开户银行名',
    accountNo: '请输入开户银行帐号',
    accountLicense: '请上传开户许可证'
};
export var additionalCertRules = {
    // foreignTradeRegistry(value, values) {
    //   if (values.foreignTradeCert) {
    //     return !value ? '请上传对外贸易经营者备案登记表附件' : '';
    //   }
    //   return '';
    // },
    // foreignTradeCode(value, values) {
    //   if (values.foreignTradeCert) {
    //     return !value ? '请填写进出口企业代码号' : '';
    //   }
    //   return '';
    // },
    manufactorType: '请选择厂家类型',
};
export var userInfoRules = {
    idCardNo: function (value) {
        if (!value) {
            return '身份证号码不能为空';
        }
        return !patterns.idCard.test(value) ? '身份证号码格式不正确' : '';
    },
    idCardExpiryDate: function (value) {
        if (!value || !(value[0] && value[1])) {
            return '请选择身份证有效期';
        }
        return '';
    },
    username: function (value) {
        if (!value) {
            return '请输入姓名';
        }
        if (value.length < 2) {
            return '姓名不能少于2个汉字';
        }
        return /^[\u4e00-\u9fa5]{2,20}$/.test(value) ? '' : '姓名只能输入中文';
    },
    identityCardFrontUrl: '请上传身份证人像面',
    identityCardBackUrl: '请上传身份证国徽面',
};
/**
 * 物流个人司机端app下载二维码
 */
export var WL_APP_QR = 'https://common-prod.oss-cn-beijing.aliyuncs.com/1e9d605832074a64955ba5745098039b.png';
export var maxDateTimestamp = +dayjs('2099-12-31');
export var authorizationFilesPath = '/assets/files/企业操作人授权书模板.docx';
export var randomKey = genarateRandomString();
